// extracted by mini-css-extract-plugin
export default {"BottomNav":"BottomNav_BottomNav__ZLFqm","active":"BottomNav_active__DqE7a"};